import { defineStore } from 'pinia'
import { getUserAuthorityTree } from '@/api/authority'
import { treeToFlat, awaitCatch } from '@/utils/commonFunc'
import { getUserInfo } from "@/api/common"

const DEFAULT_COLOR = 'cerulean'
const DEFAULT_BG = 'light'


export const useUserStore = defineStore('user', {

  state: () => {
    return {
      userData: null,
      sysAuthorities: [],
      teamAuthorities: [],
      projectAuthorities: [],
      themeBg: DEFAULT_BG,
      themeColor: DEFAULT_COLOR,
      companyEdit: {
        id: '',
        name: '',
        contact: '',
        description: '',
        website: '',
      },
      appEdit: {
        id: '',
        name: '',
        responsibleUser: '',
        description: '',
        icon: ''
      }
    }
  },

  getters: {
    allAuthorities() {
      const allTree = [...this.sysAuthorities, ...this.teamAuthorities, ...this.projectAuthorities]
      const authObjFlated = treeToFlat(allTree, [])
      return authObjFlated.map(item => item.remark)
    },
  },

  actions: {
    // 重置数据
    reset() {
      this.$reset()
    },
    setUserData(data) {
      this.userData = data
      // 清空数据
      if (!data) {
        this.sysAuthorities = []
        this.teamAuthorities = []
        this.projectAuthorities = []
        // 置空主题
        this.resetTheme()
      }
    },
    async setUserAuthorityTree(type, id) {
      try {
        if (type === 'sys') {  // 登录成功之后 获取系统权限
          this.sysAuthorities = await getUserAuthorityTree(0, id)
        }
        if (type === 'team') {  //选中团队 获取团队权限

          this.teamAuthorities = await getUserAuthorityTree(1, id)
        }
        if (type === 'project') {  // 选中项目获取项目权限
          this.projectAuthorities = await getUserAuthorityTree(2, id)
        }
      } catch (error) {
        console.log(`获取 系统、团队、项目权限失败`);
      }
    },
    // 获取用户信息
    async getUserInfo() {
      const [err, res] = await awaitCatch(getUserInfo())
      // 获取信息失败不往下走
      if (err) {
        console.log("getUserInfo ~ err:", err)
        return
      }
      // 设置用户数据
      this.setUserData(res)
      // 获取系统权限
      const [_, systemAuths] = await awaitCatch(getUserAuthorityTree(0))
      if (systemAuths) {
        console.log(_);
        this.sysAuthorities = systemAuths

      }
      // 设置主题
      this.initTheme()
    },
    // 初始化主题
    initTheme() {
      const userId = this.userData?.id
      if (userId) {
        const themeCache = localStorage.getItem(`theme_${userId}`) || `${DEFAULT_COLOR}_${DEFAULT_BG}`

        if (themeCache.match('_')) {
          const [color, bg] = themeCache.split('_')
          this.themeBg = bg
          this.themeColor = color
        } else {
          // 兼容没有bg的
          this.themeBg = DEFAULT_BG
          this.themeColor = themeCache
        }
        
      } else {
        this.themeBg = DEFAULT_BG
        this.themeColor = DEFAULT_COLOR  
      }
      this.setThemeBg(this.themeBg)
      this.setThemeColor(this.themeColor)
    },
    // 重置主题
    resetTheme() {
      document.documentElement.className = ''
    },
    // 设置主题颜色
    setThemeColor(color) {
      
      if (color) {
        this.themeColor = color
        const themeName = `theme-primary-${color} theme-bg-${this.themeBg}`
        document.documentElement.className = themeName
        
        this.saveTheme(this.themeColor, this.themeBg)

      } else {
        // 重置主题（退出登录时）
        document.documentElement.className = ''
      }
    },
    // 设置主题背景
    setThemeBg(bg) {
      if (bg) {
        this.themeBg = bg
        const themeName = `theme-primary-${this.themeColor} theme-bg-${this.themeBg}`
        document.documentElement.className = themeName
        
        this.saveTheme(this.themeColor, this.themeBg)

      } else {
        // 重置主题（退出登录时）
        document.documentElement.className = ''
      }
    },
    // 保存主题
    saveTheme(color, bg) {
      const userId = this.userData?.id || '0'
      localStorage.setItem(`theme_${userId}`, `${color}_${bg}`)
    },
    // 企业编辑
    setCompany({ id, name, contact, website, description }) {
      this.companyEdit = { id, name, contact, website, description }
    },
    // 应用编辑
    setApp({ id, name, responsibleUser, responsibleUserFullName,  icon, description, responsibleUserList }) {
      this.appEdit = { id, name, responsibleUser, responsibleUserFullName, icon, description, responsibleUserList }
    }
  }
})
